import { render, staticRenderFns } from "./address-capture.vue?vue&type=template&id=78add95a&"
import script from "./address-capture.vue?vue&type=script&lang=js&"
export * from "./address-capture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports